// SnegaDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import snegadocImg from '../../../../assets/images/Doctorsimages/dr.snega.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const SnegaDoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    document.title = "Dr. Snega M | Best Consultant Dentist | BDS – Expert Oral Care & Dental Services";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Snega M (BDS), a trusted Consultant Dentist specializing in general dentistry, smile restoration, and preventive oral health. Experience expert care at Krishna Dental Clinic. Book your dental appointment today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dentist in Puducherry, consultant dentist, BDS doctor, dental clinic near me, oral health specialist, tooth decay treatment, dental implants consultation, preventive dentistry, professional dentist for kids, Sri Venkateshwaraa Dental College alumni, general dental checkup, scaling and polishing, painless tooth extraction, Krishna Dental Clinic, Vishnu Dhanvanthri Dental Clinic, smile makeover specialist"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-snega-m-dentist-puducherry";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    
    // Add PDF-specific class to container
    container.classList.add('veenadoc-pdf-mode');

    // Store original styles to restore later
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');

    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter,
        opacity: el.style.opacity
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
      // Ensure images and containers are fully visible
      if (el.tagName === 'IMG' || el.classList.contains('veenadoc-image-container')) {
        el.style.opacity = '1';
      }
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    // Increased timeout to ensure browser has processed style changes and image is ready
    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        useCORS: true, // Crucial for loading images
        allowTaint: false,
        backgroundColor: '#ffffff',
        logging: false,
        imageTimeout: 0, // No timeout for images
      }).then(canvas => {
        // Restore original styles
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
            el.style.opacity = original.opacity;
          }
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Snega_M_Dental_Profile.pdf');
      }).catch(err => {
        console.error("PDF Generation Error:", err);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 500); // Increased delay to 500ms for better image capture reliability
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Snega M</span>
                  <span className="veenadoc-title-credentials">(BDS)</span>
                  <span className="veenadoc-title-location">Consultant Dentist</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A trusted name in modern dentistry, Dr. Snega M is a dedicated <strong>Consultant Dentist</strong> known for her 
                    gentle touch and precision. Specializing in comprehensive oral care, she blends clinical excellence 
                    with a compassionate approach to ensure every patient achieves a healthy, radiant smile.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">🦷</span>
                    <span>Book Dental Appointment</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      {/* Added crossOrigin and ensure alt/title are present */}
                      <img 
                        src={snegadocImg} 
                        alt="Dr. Snega M – Professional Consultant Dentist (BDS)" 
                        className="veenadoc-doctor-image" 
                        title='Dr. Snega M – Professional Consultant Dentist'
                        crossOrigin="anonymous"
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>Academic Excellence & Foundation</h2>
                  <p>
                    Dr. Snega M earned her Bachelor of Dental Surgery (BDS) from the esteemed <strong>Sri Venkateshwaraa Dental College, Pondicherry University</strong>. 
                    Her academic background is rooted in evidence-based dentistry, where she mastered the latest protocols in oral surgery, 
                    restorative procedures, and preventive care. This strong foundation allows her to provide treatments that are not only 
                    effective but also minimally invasive.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Doctor Profile Summary</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialty:</span>
                      <span className="veenadoc-info-value">General & Preventive Dentistry</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Education:</span>
                      <span className="veenadoc-info-value">BDS (Pondicherry University)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">Clinical Consultant</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Focus:</span>
                      <span className="veenadoc-info-value">Patient Comfort & Oral Hygiene</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Professional Clinical Journey</h2>
                  <p>
                    Throughout her professional journey, Dr. Snega has been associated with premier dental institutions, refining her 
                    skills in high-pressure clinical environments. She currently serves as a Consultant Dentist at:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Krishna Dental Clinic & Implant Centre:</strong> Focusing on advanced restorations and implant consultations.</li>
                    <li><strong>Vishnu Dhanvanthri Dental Clinic:</strong> Dedicated to family dentistry and preventive oral health programs.</li>
                  </ul>
                  <p>
                    Her experience across these centers has equipped her to handle a diverse range of dental conditions, from acute 
                    toothaches and infections to long-term smile rehabilitation.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>The Art of Gentle Dentistry</h2>
                  <p>
                    Dr. Snega M understands that many patients experience "dental anxiety." To address this, she has developed a 
                    treatment style that prioritizes <strong>patient comfort and clear communication</strong>. Every procedure begins 
                    with a detailed explanation, ensuring the patient is informed and relaxed. 
                  </p>
                  <p>
                    By utilizing modern techniques and a gentle clinical touch, she ensures that even complex treatments like 
                    extractions or deep cleanings are as painless as possible. Her goal is to change the way patients perceive 
                    dental visits—from a chore to a vital part of their self-care routine.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Dental Solutions</h2>
                  <p>
                    Dr. Snega offers a wide spectrum of services designed to cater to the unique needs of every age group:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Comprehensive Smile Assessments:</strong> Utilizing detailed oral exams to map out long-term health.</li>
                    <li><strong>Advanced Restorative Care:</strong> Using biocompatible materials for fillings and crowns that look and feel natural.</li>
                    <li><strong>Scaling & Periodontal Therapy:</strong> Deep cleaning to prevent gum disease and maintain systemic health.</li>
                    <li><strong>Pediatric Dental Care:</strong> A friendly approach to ensure children grow up with healthy dental habits.</li>
                    <li><strong>Implant & Prosthetic Consultations:</strong> Helping patients explore modern options for missing teeth.</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block">
                  <h2>The Link Between Oral & Systemic Health</h2>
                  <p>
                    A key aspect of Dr. Snega’s philosophy is her focus on the "Oral-Systemic Connection." She educates her patients 
                    on how oral infections and gum disease can impact overall health, including heart health and diabetes management. 
                    This holistic view ensures that her treatments contribute to the patient's total well-being, not just their teeth.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>A Commitment to Your Confidence</h2>
                  <p>
                    Choosing Dr. Snega M means choosing a partner in your health journey. She is committed to providing 
                    ethical, transparent, and high-quality dental care. Whether you need a simple checkup or a complete 
                    smile transformation, Dr. Snega is here to guide you with expertise and care.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her Vision:</strong> To provide every patient with a functional, healthy, and beautiful smile that lasts a lifetime.
                  </p>
                </div>
              </div>

              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">✨</div>
                    <blockquote style={{fontSize: '1.1rem'}}>
                      "I believe that a healthy smile is the foundation of overall well-being. My mission is to treat every patient with integrity, ensuring their comfort is never compromised."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Snega M's Care Philosophy</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Krishna Dental Clinic</h4>
                      <p>Implant & Restorative Center</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Vishnu Dhanvanthri Clinic</h4>
                      <p>General & Family Dentistry</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Smile Consultation</h3>
                  <p>Ready for a healthier smile? Book your session with Dr. Snega M today.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Call for Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Snega's Full Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default SnegaDoc;
